import { ResultOf } from "gql.tada";
import { GetContentHubPageById } from "@queries/archetypes/GetContentHubPageById";
import { Hero } from "@components/entries/Hero";
import { InsightsBlockGroup } from "@components/entries/InsightsBlockGroup";
import { RoutingSection } from "@components/entries/RoutingSection";

type ContentHubPageData = NonNullable<
  ResultOf<typeof GetContentHubPageById>["contentHubPage"]
>;

export const ContentHubPageRenderer = ({
  data,
}: {
  data: ContentHubPageData;
}) => {
  return (
    <>
      {data.hero && (
        <Hero entry={{ hero: data.hero } as any} />
      )}
      {data.insights && (
        <InsightsBlockGroup
          entry={{ insightsBlockGroup: data.insights } as any}
        />
      )}
      {data.routing && (
        <RoutingSection
          entry={{ routingSection: data.routing } as any}
        />
      )}
    </>
  );
};
